import { Flex } from 'portal-commons';
import { Grid } from '@material-ui/core';
import { CampaignSharingStatus } from '@/apis/core';
import { humanize } from '@/utils/string';

export default function CNPDetails(props) {
  const {
    variant = 'csp', // 'csp' or 'cnp'
    nominationInfo,
  } = props;
  const statusColor =
    nominationInfo.status === CampaignSharingStatus.Pending
      ? '#00425B'
      : nominationInfo.status === CampaignSharingStatus.Accepted
      ? '#3B5000'
      : nominationInfo.status === CampaignSharingStatus.Declined
      ? '#5C0825'
      : '#19262A';
  const statusBackground =
    nominationInfo.status === CampaignSharingStatus.Pending
      ? '#99DBF4'
      : nominationInfo.status === CampaignSharingStatus.Accepted
      ? '#D4E999'
      : nominationInfo.status === CampaignSharingStatus.Declined
      ? '#F5A1BE'
      : '#E6E7E7';

  return (
    <>
      <div
        className="cnp-dca-details"
        style={{
          ...(variant === 'cnp' ? { borderBottom: 'none' } : {}),
        }}
        data-testid="cnpDcaDetails"
      >
        <Grid container alignItems="center">
          <Grid
            style={{
              paddingTop: 20,
              paddingBottom: variant === 'csp' ? 20 : 0,
            }}
            item
            xs={4}
          >
            <div
              className="cnp-details-wrapper"
              data-testid="cnpDcaDetailsConnectivityPartner"
            >
              <Grid item xs={6}>
                <p className="paragraph">Connectivity Partner:</p>
              </Grid>
              <Grid container xs={6} className="flex-centered">
                <p className="paragraph">
                  <span>
                    {nominationInfo.upstreamCnpName
                      ? nominationInfo.upstreamCnpName
                      : nominationInfo.upstreamCnpUid
                      ? nominationInfo.upstreamCnpUid
                      : 'NONE'}
                  </span>
                </p>
              </Grid>
            </div>
          </Grid>
          <Grid
            style={{
              paddingTop: 20,
              paddingBottom: variant === 'csp' ? 20 : 0,
            }}
            item
            xs={4}
          >
            <div
              className="cnp-details-wrapper"
              data-testid="cnpDcaDetailsUpstreamSharingStatus"
            >
              <Flex sx={{ alignItems: 'center', gap: 'm' }}>
                <p className="paragraph">Upstream Sharing Status</p>
                <Flex
                  sx={{
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '20px',
                    padding: '0 6px',
                    borderRadius: '4px',
                    color: statusColor,
                    background: statusBackground,
                    fontWeight: 400,
                    fontSize: '10px',
                    lineHeight: 'normal',
                  }}
                >
                  {humanize(nominationInfo.status) || 'None'}
                </Flex>
              </Flex>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
}
